import Magistrado from '@/model/Magistrado';
import { uiStore } from '@/store';
import { mapToPageablePayload } from '@/utils/ApiUtils';
import { RestApi } from '@pjn/ajax/Api';
import { AxiosInstance } from '@pjn/ajax/HttpClient';
import { OptionalId } from '@pjn/core/model/helpers/Types';
import { toEntity } from '@pjn/ajax/helpers';
import Denuncia from '@/model/Denuncia';
import { mapDenunciaFrom, mapDenunciaTo } from './utils/Mappers';

/** URL base de la API de magistrados */
const DENUNCIA_URL = process.env.VUE_APP_DENUNCIAS_URL + '/denuncia';
const REPORTE_URL = process.env.VUE_APP_DENUNCIAS_URL + '/reporte/denuncia';




export class DenunciaRestApi extends RestApi<Magistrado> {
  constructor(http: AxiosInstance) {
    super(http, DENUNCIA_URL);
  }
  save(denuncia: OptionalId<Denuncia>) {

    return this.http
      .put(`${DENUNCIA_URL}`, mapDenunciaFrom(denuncia))
      .then(toEntity<Denuncia>(mapDenunciaTo))
      .catch(error => {
        throw error;
      });
  }
    createDenuncia(denuncia: OptionalId<Denuncia> ) {
    return this.http
      .post(
        `${DENUNCIA_URL}`, mapDenunciaFrom(denuncia))
      .then(toEntity<Denuncia>(mapDenunciaTo))
    }

    findById(id: number) {
    return this.http
      .get(`${DENUNCIA_URL}` + '/' + id)
      .then(toEntity<Denuncia>(mapDenunciaTo))
      .catch(error => {
        if (error.code !== '4033') {
          uiStore.notification.error(error);
        }
        return Promise.reject(error);
      });
    }
    
    deleteDenuncia(id: number) {
    return this.http
      .delete(`${DENUNCIA_URL}` + '/' + id)
      .catch(error => {
          uiStore.notification.error(error);
          return Promise.reject(error.message || error);
      });
  }
    
  async getDenuncias(query: string) {
    const response = await this.http.get(`${DENUNCIA_URL}${query}&sort=altaFecha,desc&sort=magistrado.apellido,asc&sort=magistrado.nombre,asc`).catch(error => {
      uiStore.notification.error(error.message || error);
      return Promise.reject(error.message || error);
    });
    return mapToPageablePayload<Denuncia>(response.data)
  }
  async getDenunciasPublicas(query: string) {
    const response = await this.http.get(`${DENUNCIA_URL}/public${query}&sort=altaFecha,desc&sort=magistrado.apellido,asc&sort=magistrado.nombre,asc`).catch(error => {
      uiStore.notification.error(error.message || error);
      return Promise.reject(error.message || error);
    });
    return mapToPageablePayload<Denuncia>(response.data)
  }
  

  reporte(query: string) {
    return this.http.get(`${REPORTE_URL}${query}sort=altaFecha,desc&sort=magistrado.apellido,asc&sort=magistrado.nombre,asc`, { responseType: 'blob',transformResponse: [function (data) {
    return data;
  }], })
      .catch(error => {
      uiStore.notification.error(error.message || error);
      return Promise.reject(error.message || error);
    });
   
  }

}